var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPop2WinLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.4,
    y: -6.7,
    transform: "matrix(0.4831 -0.8756 0.8756 0.4831 0.1047 16.3312)",
    width: 1,
    height: 29.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.8,
    y: 21.4,
    transform: "matrix(0.8812 -0.4728 0.4728 0.8812 -8.7688 8.9583)",
    width: 28.4,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7,3.3l-0.2,0c-0.2-0.1-0.3-0.4-0.2-0.6L15,1c0.1-0.2,0.4-0.3,0.6-0.2c0.2,0.1,0.3,0.4,0.2,0.6L15.2,3 C15.1,3.2,14.9,3.3,14.7,3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4,25.6l-0.2,0C4,25.4,3.9,25.2,4,24.9l1.3-2.8c0.1-0.2,0.4-0.3,0.6-0.2c0.2,0.1,0.3,0.4,0.2,0.6l-1.3,2.8 C4.8,25.5,4.6,25.6,4.4,25.6z M6.9,20.3l-0.2,0c-0.2-0.1-0.3-0.4-0.2-0.6l1.5-3.3c0.1-0.2,0.4-0.3,0.6-0.2c0.2,0.1,0.3,0.4,0.2,0.6 L7.3,20C7.2,20.2,7,20.3,6.9,20.3z M9.5,14.6l-0.2,0c-0.2-0.1-0.3-0.4-0.2-0.6l1.5-3.3c0.1-0.2,0.4-0.3,0.6-0.2 c0.2,0.1,0.3,0.4,0.2,0.6L10,14.3C9.9,14.5,9.7,14.6,9.5,14.6z M12.2,8.8l-0.2,0c-0.2-0.1-0.3-0.4-0.2-0.6l1.5-3.3 c0.1-0.2,0.4-0.3,0.6-0.2c0.2,0.1,0.3,0.4,0.2,0.6l-1.5,3.3C12.5,8.7,12.4,8.8,12.2,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1,28.4l-0.2,0c-0.2-0.1-0.3-0.4-0.2-0.6l0.8-1.6c0.1-0.2,0.4-0.3,0.6-0.2c0.2,0.1,0.3,0.4,0.2,0.6l-0.8,1.6 C3.5,28.3,3.3,28.4,3.1,28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5,30c-0.2,0-0.4-0.1-0.4-0.3l-0.8-1.6c-0.1-0.2,0-0.5,0.2-0.6c0.2-0.1,0.5,0,0.6,0.2l0.8,1.6c0.1,0.2,0,0.5-0.2,0.6 L29.5,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6,25.9c-0.2,0-0.4-0.1-0.4-0.3l-1.7-3.5c-0.1-0.2,0-0.5,0.2-0.6c0.2-0.1,0.5,0,0.6,0.2l1.7,3.5c0.1,0.2,0,0.5-0.2,0.6 L27.6,25.9z M24.7,19.7c-0.2,0-0.4-0.1-0.4-0.3l-1.7-3.5c-0.1-0.2,0-0.5,0.2-0.6c0.2-0.1,0.5,0,0.6,0.2l1.7,3.5 c0.1,0.2,0,0.5-0.2,0.6L24.7,19.7z M21.8,13.5c-0.2,0-0.4-0.1-0.4-0.3l-1.7-3.5c-0.1-0.2,0-0.5,0.2-0.6c0.2-0.1,0.5,0,0.6,0.2 l1.7,3.5c0.1,0.2,0,0.5-0.2,0.6L21.8,13.5z M18.9,7.3c-0.2,0-0.4-0.1-0.4-0.3L17,4c-0.1-0.2,0-0.5,0.2-0.6c0.2-0.1,0.5,0,0.6,0.2 l1.4,3.1c0.1,0.2,0,0.5-0.2,0.6L18.9,7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9,3c-0.2,0-0.4-0.1-0.4-0.3l-0.8-1.6c-0.1-0.2,0-0.5,0.2-0.6c0.2-0.1,0.5,0,0.6,0.2l0.8,1.6c0.1,0.2,0,0.5-0.2,0.6 L16.9,3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 11.2,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8,29.8H0V0h29.8V29.8z M1,28.9h27.9V1H1V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4,25.9H4v-22h22.4V25.9z M4.9,25h20.6V4.8H4.9V25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPop2WinLeft);
export default __webpack_public_path__ + "static/media/pop_2win_left.5d83495bddcc7064864335e1d4de8d8e.svg";
export { ForwardRef as ReactComponent };